<template>
  <div class="container onboard-container">
    <div v-if="showSpinner" class="columns">
      <div class="column is-12 is-margin-top-40">
        <p class="has-text-centered">
          <img src="/static/img/ajax-loader.gif" alt="Verifying payment..." />
        </p>
      </div>
    </div>
    <div class="columns" v-if="!show_thank_you && !showSpinner">
      <div class="column is-two-thirds equal-height">
        <div class="form-box">
          <h1 class="Create-your-account">Checkout</h1>
          <p class="form-para has-text-centered mar-top-10" v-html="checkoutCopy"></p>
          <h6 class="Business-details mar-bot-16">Select&nbsp;payment&nbsp;method</h6>
          <form>
            <div class="field">
              <div class="control">
                <label class="radio label-filters">
                  <input type="radio" v-model="form.payment_method" name="payment_method" value="credit_card" />&nbsp;&nbsp;&nbsp;Credit Card
                </label>
              </div>
              <div class="control">
                <label class="radio label-filters">
                  <input type="radio" v-model="form.payment_method" name="payment_method" value="eft" />&nbsp;&nbsp;&nbsp;EFT
                </label>
              </div>
            </div>
            <h6 class="User-details mar-bot-16" v-html="paymentMethod"></h6>
            <div v-if="isCreditCardPaymentMethod" class="field is-grouped is-grouped-multiline">
              <div class="control">
                <input autocomplete="cc-csc" v-model="form.selected_cc_name" class="input" type="text" placeholder="Card holder name" />
                <p class="help is-danger" v-if="form.errors.has('selected_cc_name')" v-text="form.errors.get('selected_cc_name')"></p>
              </div>
              <div class="control">
                <input autocomplete="cc-csc" class="input" type="text" v-model="form.selected_cc_number" placeholder="Credit card number" />
                <p class="help is-danger" v-if="form.errors.has('selected_cc_number')" v-text="form.errors.get('selected_cc_number')"></p>
              </div>
            </div>
            <div v-if="isCreditCardPaymentMethod" class="field is-grouped is-hidden-mobile">
              <div class="control">
                <custom-drop-down @changed="setCreditCardMonth" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Month" dropdown-name="credit_card_month" :items="months"></custom-drop-down>
              </div>
              <div class="control">
                <custom-drop-down @changed="setCreditCardYear" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Year" dropdown-name="credit_card_year" :items="years"></custom-drop-down>
              </div>
              <div class="control cc_info">
                <input autocomplete="cc-csc" class="input cc_field" v-model="form.selected_cc_ccv" type="text" placeholder="CVV" /><tooltip-new class="rel-pos" content-width="160px">The last 3 digits at the back of your card</tooltip-new>
              </div>
              <div class="control">
                <div class="level is-mobile">
                  <div class="level-right">
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isVisa }]" alt="Visa" srcset="/static/img/creditcard/visa.png, /static/img/creditcard/visa@2x.png 2x, /static/img/creditcard/visa@3x.png 3x" src="/static/img/creditcard/visa.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isMasterCard }]" alt="Master Card" srcset="/static/img/creditcard/mastercard.png, /static/img/creditcard/mastercard@2x.png 2x, /static/img/creditcard/mastercard@3x.png 3x" src="/static/img/creditcard/mastercard.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isAmex }]" alt="American Express" srcset="/static/img/creditcard/amex.png, /static/img/creditcard/amex@2x.png 2x, /static/img/creditcard/amex@3x.png 3x" src="/static/img/creditcard/amex.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isCreditCardPaymentMethod" class="field is-hidden-tablet">
              <div class="control">
                <custom-drop-down @changed="setCreditCardMonth" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Month" dropdown-name="credit_card_month" :items="months"></custom-drop-down>
              </div>
            </div>
            <div v-if="isCreditCardPaymentMethod" class="field is-hidden-tablet">
              <div class="control">
                <custom-drop-down @changed="setCreditCardYear" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Year" dropdown-name="credit_card_year" :items="years"></custom-drop-down>
              </div>
            </div>
            <div v-if="isCreditCardPaymentMethod" class="field is-hidden-tablet">
              <div class="control cc_info">
                <input autocomplete="cc-csc" class="input cc_field" v-model="form.selected_cc_ccv" type="text" placeholder="CVV" /><tooltip-new class="rel-pos" content-width="160px">The last 3 digits at the back of your card</tooltip-new>
              </div>
            </div>
            <div v-if="isCreditCardPaymentMethod" class="field is-hidden-tablet">
              <div class="control">
                <div class="level is-mobile">
                  <div class="level-right">
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isVisa }]" alt="Visa" srcset="/static/img/creditcard/visa.png, /static/img/creditcard/visa@2x.png 2x, /static/img/creditcard/visa@3x.png 3x" src="/static/img/creditcard/visa.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isMasterCard }]" alt="Master Card" srcset="/static/img/creditcard/mastercard.png, /static/img/creditcard/mastercard@2x.png 2x, /static/img/creditcard/mastercard@3x.png 3x" src="/static/img/creditcard/mastercard.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isAmex }]" alt="American Express" srcset="/static/img/creditcard/amex.png, /static/img/creditcard/amex@2x.png 2x, /static/img/creditcard/amex@3x.png 3x" src="/static/img/creditcard/amex.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h6 v-if="isGrowthPlan" class="User-details mar-bot-16">Billing&nbsp;cycle</h6>
            <div v-if="isGrowthPlan" class="field has-addons billing-cycle">
              <p class="control">
                <button @click.prevent="setBillingCycleMonthly" :class="['button', { 'is-active' : !is_annual}]"><span>Monthly</span></button>
              </p>
              <p class="control">
                <button @click.prevent="setBillingCycleAnnual" :class="['button', { 'is-active' : is_annual}]"><span>Annual</span></button>
              </p>
              <p v-if="isGrowthPlan" class="control">
                <span class="discount_copy">Save&nbsp;10&#37;</span>
              </p>
            </div>
            <h6 class="User-details mar-bot-16">Billing&nbsp;information</h6>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <input autocomplete="cc-csc" v-model="form.registered_business_name" class="input" type="text" placeholder="Registered business name" />
              </div>
              <div class="control">
                <input autocomplete="cc-csc" v-model="form.registered_address" class="input" type="text" placeholder="Address" />
              </div>
            </div>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <input autocomplete="cc-csc" v-model="form.registration_number" class="input" type="text" placeholder="Registration number (optional)" />
              </div>
              <div class="control">
                <input autocomplete="cc-csc" v-model="form.vat_number" class="input" type="text" placeholder="VAT number (optional)" />
              </div>
            </div>
            <p class="has-text-centered">
              <button @click.prevent="finishOnboard" :disabled="is_sending || !allRequiredFieldsFilled" :class="['button create-account', { 'is-loading' : is_sending }]" v-html="submitButtonCopy"></button>
            </p>
          </form>
          <div class="flash-msg columns is-mobile is-marginless" v-if="is_payment_error">
            <div class="column is-narrow is-paddingless is-marginless is-centered is-danger has-text-centered">
              <span class="icon is-size-4 is-white">
                <i class="fas fa-ban"></i>
              </span>
            </div>
            <div class="column is-marginless is-paddingless is-hidden-mobile">
              <p>We couldn't process your payment. Please take a moment to review your billing information.</p>
            </div>
            <div class="column is-marginless is-paddingless is-hidden-tablet">
              <p>We couldn't process your payment</p>
            </div>
          </div>
        </div>
      </div>
      <summary-section :cycle="getFrequency" :name="tier"></summary-section>
    </div>
    <!-- START ReCaptcha -->
    <div class="columns" v-if="!show_thank_you && !showSpinner">
      <div class="column is-marginless">
        <div class="has-text-right-tablet">
          <vue-recaptcha
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            size="invisible"
            :sitekey="`${google_recaptcha_site_key}`">
          </vue-recaptcha>
        </div>
      </div>
    </div>
    <!-- END ReCaptcha -->
    <!-- CREDIT CARD THANK YOU -->
    <div class="hero thank-you-hero" v-if="show_thank_you && !showSpinner && !show_thank_you_eft">
      <div class="hero-body">
        <div class="has-text-centered">
          <div class="outter-ring">
            <div class="inner-ring">
              <img src="/static/img/packages/like_icon.svg" width="60"/>
            </div>
          </div>
          <h1 class="thank-you-header is-size-1-widescreen is-size-2-tablet is-size-2-desktop is-size-4-mobile has-text-weight-bold height-100">Congratulations</h1>
          <p class="thank-you-msg"><span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>We're glad to have you on board. <a href="/login">Sign in</a> to Portal to get started</p>
        </div>
      </div>
    </div>
    <!-- EFT THANK YOU -->
    <div class="hero thank-you-hero" v-if="show_thank_you && !showSpinner && show_thank_you_eft">
      <div class="hero-body">
        <div class="has-text-centered">
          <div class="outter-ring">
            <div class="inner-ring">
              <img src="/static/img/packages/like_icon.svg" width="60"/>
            </div>
          </div>
          <h1 class="thank-you-header is-size-1-widescreen is-size-2-tablet is-size-2-desktop is-size-4-mobile has-text-weight-bold">Your business profile<br/>is in our hands.</h1>
          <p class="thank-you-msg" v-html="showThankYouMessage"></p>
        </div>
      </div>
    </div>
    <!-- EFT THANK YOU INVOICE -->
    <div class="columns" v-if="show_thank_you && !showSpinner && show_thank_you_eft">
      <div class="column is-two-thirds equal-height">
        <div class="form-box">
          <h1 class="Create-your-account">EFT</h1>
          <p class="has-text-centered mar-top-10">Please make payment to the following bank account</p>
          <table class="table">
            <tr>
              <td>Bank</td>
              <td>Nedbank</td>
            </tr>
            <tr>
              <td>Account number</td>
              <td>1084&nbsp;211&nbsp;319</td>
            </tr>
            <tr>
              <td>Account name</td>
              <td>TKJ Design (Pty) Ltd T/A hellopeter.com</td>
            </tr>
            <tr>
              <td>Branch</td>
              <td>198765, Business Southern Peninsula</td>
            </tr>
            <tr>
              <td>Your reference</td>
              <td>123456</td>
            </tr>
            <tr>
              <td colspan="2">Send proof of payment to <a href="mailto:accounts@hellopeter.com">accounts@hellopeter.com</a></td>
            </tr>
          </table>
          <p class="has-text-centered"><a :href="`https://dev.hellopeter.api/invoices/${downloadInvoice}/file`">Download invoice</a></p>
          <p class="has-text-centered"><button class="button ok-button">OK</button></p>
        </div>
      </div>
      <summary-section :cycle="getFrequency" :name="tier"></summary-section>
    </div>
    <form class="is-invisible" name="forwardToPurchaseNewOnboardGateway" v-if="redirectParams.length > 0 && !showSpinner" method="post" :action="redirectAction" target="_self">
      <p>Please have your phone ready to obtain a One Time Pin</p>
      <input v-for="param in redirectParams" :name="param.name" :value="param.value" :key="param.name" type="hidden" />
      <input type="submit" class="button is-button-blue-outline is-fullwidth" value="Click here to continue" />
    </form>
  </div>
</template>
<script>
/* eslint-disable no-undef */
import axios from 'axios'
import ApiResource from '../../api/ApiResource'
import { TooltipNew } from '@/widgets'
import VuePassword from 'vue-password'
import CustomDropDown from './../../components/DropDownGeneric'
import SummarySection from './../../components/Summary'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'CheckoutOnboard',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Checkout'
  },
  props: {
    business_id: {
      type: String
    },
    tier: {
      type: String,
      default: 'free'
    },
    frequency: {
      type: String,
      default: 'monthly'
    },
    invoice: {
      type: String,
      default: ''
    }
  },
  components: {
    CustomDropDown,
    VuePassword,
    SummarySection,
    TooltipNew,
    VueRecaptcha
  },
  data () {
    return {
      showSpinner: false,
      is_payment_error: false,
      form: new ApiResource({
        business_id: this.business_id,
        payment_method: 'credit_card',
        selected_cc_number: '',
        selected_cc_name: '',
        selected_cc_month: '',
        selected_cc_year: '',
        selected_cc_ccv: '',
        selected_cc_type: '',
        billing_cycle: 'NONE',
        registered_address: '',
        registered_business_name: '',
        registration_number: '',
        vat_number: '',
        invoice_id: this.invoice,
        tier: this.tier,
        token: '',
        card_return_url: ''
      }),
      billingAxios: undefined,
      redirectParams: [],
      redirectAction: '',
      google_recaptcha_site_key: process.env.GOOGLE_RECAPCHA_SITE_KEY,
      recaptchaToken: '',
      is_sending: false,
      show_thank_you: false,
      show_thank_you_eft: false,
      is_annual: true,
      payment_method: 'credit_card',
      show_industry_dropdown: false,
      industry_dropdown_fullwidth: true,
      small_credit_card: true,
      card_number: '',
      months: [
        {name: '01', value: '01'},
        {name: '02', value: '02'},
        {name: '03', value: '03'},
        {name: '04', value: '04'},
        {name: '05', value: '05'},
        {name: '06', value: '06'},
        {name: '07', value: '07'},
        {name: '08', value: '08'},
        {name: '09', value: '09'},
        {name: '10', value: '10'},
        {name: '11', value: '11'},
        {name: '12', value: '12'}
      ],
      years: [],
      selected_cc_month: '',
      selected_cc_year: '',
      selected_cc_ccv: '',
      selected_cc_name: '',
      selected_cc_number: '',
      selected_cc_type: '',
      registered_business_name: '',
      registered_address: '',
      registration_number: '',
      vat_number: '',
      invoice_id: '', // blank for new invoice. If CC payment fails, we would've created an invoice and should populate here
      downloadInvoice: ''
    }
  },
  created () {
    this.billingAxios = axios.create({
      baseURL: process.env.API_URL
    })
  },
  mounted () {
    this.is_annual = this.frequency === 'annual'
    this.form.billing_cycle = this.frequency.toUpperCase()
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Onboard checkout'
    })
    let yr = []
    const currentYear = new Date().getFullYear()
    for (let i = 0; i < 11; i++) {
      const currentValue = (i + currentYear).toString()
      yr.push({name: currentValue, value: currentValue})
    }
    this.years = yr
    this.invoice_id = this.invoice

    if (this.$route.query['id'] !== undefined) {
      this.showCreditCardProcessing()
    }
  },
  computed: {
    showThankYouMessage () {
      // change message based on whether or not the package is free
      const dummyEmail = 'test@test.com'
      const bold = `<span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>`
      const remainder = `Our team will review your information. Once this is done, your account<br/>will be activated and a welcome email will be sent to ${dummyEmail} to get you started.`
      return bold + remainder
    },
    checkoutCopy () {
      return `Secured&nbsp;checkout.&nbsp;Billed&nbsp;monthly.&nbsp;Cancel&nbsp;anytime.`
    },
    isGrowthPlan () {
      const growth = ['g1', 'g2', 'g3', 'g4']
      return growth.indexOf(this.tier) !== -1
    },
    paymentMethod () {
      return this.form.payment_method === 'credit_card' ? `Credit&nbsp;card` : `EFT`
    },
    submitButtonCopy () {
      return this.form.payment_method === 'credit_card' ? `PAY&nbsp;NOW` : `SUBMIT`
    },
    isCreditCardPaymentMethod () {
      return this.form.payment_method === 'credit_card'
    },
    isAmex () {
      const card = this.form.selected_cc_number.trim()
      return card.length === 15 && (card.startsWith('34') || card.startsWith('37'))
    },
    isVisa () {
      const card = this.form.selected_cc_number.trim()
      return card.startsWith('4') && (card.length === 13 || card.length === 16)
    },
    isMasterCard () {
      const card = this.form.selected_cc_number.trim()
      return card.length === 16 && (card.startsWith('51') || card.startsWith('52') || card.startsWith('53') || card.startsWith('54') || card.startsWith('55'))
    },
    getFrequency () {
      if (this.is_annual) {
        return 'annual'
      }
      return 'monthly'
    },
    getCardType () {
      const card = this.form.selected_cc_number.trim()
      if (card.length === 15 && (card.startsWith('34') || card.startsWith('37'))) {
        return 'AMEX'
      }
      if (card.length === 16 && (card.startsWith('51') || card.startsWith('52') || card.startsWith('53') || card.startsWith('54') || card.startsWith('55'))) {
        return 'MASTER'
      }
      if (card.startsWith('4') && (card.length === 13 || card.length === 16)) {
        return 'VISA'
      }
      return ''
    },
    allRequiredFieldsFilled () {
      if (this.form.payment_method === 'eft') {
        if (this.form.billing_cycle === 'NONE') {
          return false
        }
        if (this.form.registered_address.trim().length === 0 || this.form.registered_business_name.trim().length === 0) {
          return false
        }
      } else {
        if (this.form.selected_cc_number.trim().length === 0 || this.form.selected_cc_name.trim().length === 0 ||
          this.form.selected_cc_month.trim().length === 0 || this.form.selected_cc_year.trim().length === 0 ||
          this.form.selected_cc_ccv.trim().length === 0 || this.form.selected_cc_type.trim().length === 0 ||
          this.form.billing_cycle === 'NONE' || this.form.registered_address.trim().length === 0 ||
          this.form.registered_business_name.trim().length === 0) {
          return false
        }
      }

      return true
    }
  },
  watch: {
    getCardType (val) {
      this.form.selected_cc_type = ''
      const allowedCards = ['AMEX', 'MASTER', 'VISA']
      if (allowedCards.indexOf(val) !== -1) {
        this.form.selected_cc_type = val
      }
    }
  },
  methods: {
    hideIndustryDropdown () {
      this.show_industry_dropdown = false
    },
    showIndustryDropdown () {
      this.show_industry_dropdown = true
    },
    closeBusinessAutocomplete () {
      console.log('closing business autocomplete')
    },
    selectIndustry (event) {
      this.selected_industry = event.value
    },
    selectCompanySize (event) {
      this.selected_company_size = event.value
    },
    setBillingCycleAnnual () {
      this.is_annual = true
      this.form.billing_cycle = 'ANNUAL'
    },
    setBillingCycleMonthly () {
      this.is_annual = false
      this.form.billing_cycle = 'MONTHLY'
    },
    setCreditCardMonth (e) {
      this.form.selected_cc_month = e.value
    },
    setCreditCardYear (e) {
      this.form.selected_cc_year = e.value
    },
    onCaptchaVerified (recaptchaToken) {
      this.is_sending = true
      this.is_payment_error = false
      this.form.errors.clear()
      this.$refs.recaptcha.reset()
      this.form.token = recaptchaToken

      const currentRoute = this.$route.path
      this.form.card_return_url = location.origin + currentRoute
      if (!currentRoute.endsWith('/')) {
        this.form.card_return_url += '/'
      }

      this.form.send('/onboard/finish')
        .then((data) => {
          this.is_sending = false
          console.log('success data', data)
          if (data.success && typeof data.paymentRedirect !== 'undefined') {
            this.redirectParams = data.paymentRedirect.parameters
            this.redirectAction = data.paymentRedirect.url
            setTimeout(() => {
              document.forms['forwardToPurchaseNewOnboardGateway'].submit()
            }, 200)
          } else if (data.success && typeof data.thanksMail !== 'undefined') {
            this.show_thank_you_eft = this.show_thank_you = true
            this.downloadInvoice = data.invoice.id
          } else {
            console.log('probably a CC payment but something went wrong', data)
          }
          // this.$router.push(`/onboard/checkout/${data.business_id}/${this.tier}/${this.frequency}`)
        })
        .catch((error) => {
          if (typeof error.paymentResult !== 'undefined' && typeof error.paymentResult.parameterErrors !== 'undefined' && error.paymentResult.parameterErrors.length > 0) {
            this.is_payment_error = true
            error.paymentResult.parameterErrors.forEach((data) => {
              if (data.name === 'card.holder') {
                this.form.errors.errors['selected_cc_name'] = [data.message]
              } else if (data.name === 'card.number') {
                this.form.errors.errors['selected_cc_number'] = [data.message]
              }
            })
          }
          console.log('error sending form', error)
          this.is_sending = false
        })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    finishOnboard () {
      this.$refs.recaptcha.execute()
    },
    showCreditCardProcessing () {
      this.showSpinner = true
      const paymentToken = this.$route.query['id']
      const verifyTokenUrl = `/billing/verify-credit-card-payment/${this.invoice}/${paymentToken}`

      axios.get(verifyTokenUrl)
        .then((response) => {
          this.showSpinner = false
          if (response.data.paymentVerification.payment_successful) {
            this.show_thank_you_eft = false
            this.show_thank_you = true
            this.$gtm.trackEvent({
              event: 'AccountCreated',
              plan: `${this.tier} ${this.frequency}`
            })
          } else {
            const errorMessage = response.data.paymentVerification.result.description
            flash(errorMessage, 'is-danger', false)
          }
        })
        .catch(() => {
          console.log('error verifying payment')
          this.showSpinner = false
        })
    }
  }
}
</script>
<style scoped>

.onboard-container > .columns > .column:first-child {
  padding-bottom: 37px;
}

.onboard-container > .columns > .column:last-child {
  padding-bottom: 37px;
}

.equal-height {
  display:flex;
  flex-direction:column;
  justify-content:space-between
}

.columns .want-to-know-more {
  margin-top: auto;
}

.form-box {
  width: 100%;
  max-width: 697px;
  margin: 0 auto;
}

.Create-your-account {
  margin-top: 40px;
  font-family: 'Montserrat';
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.86;
  letter-spacing: normal;
  text-align: center;
  color: #1261a0;
}

.Business-details, .User-details {
  margin-top: 22px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.User-details {
  margin-top: 37px;
}

.form-para {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  margin-bottom: 15px;
}

.input {
  height: 40px;
  border: solid 1px #dbdbdb;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  padding-left:18px;
}

div.outter-ring {
  background-color: #f7fcfe;
  padding: 15px;
  border-radius: 50%;
  width: 185px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  padding-top: 19px;
  padding-bottom: 37px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
}

div.inner-ring {
  border-radius: 50%;
  padding: 15px;
  width: 114px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  margin-top: 19px;
  background-color: #edf8fd;
}

/*h1 {*/
/*  color: #555e65*/
/*}*/

.thank-you-hero {
  margin-top: 100px;
  margin-bottom: 100px;
}

.field.is-grouped>.control:not(:last-child) {
  margin-bottom: 0;
  margin-right: 15px;
}

.field:not(:last-child) {
  margin-bottom: 15px;
}

p + .field.is-grouped {
  margin-top: 15px;
}

/*.summary {*/
/*  font-family: Montserrat;*/
/*  margin-top: 40px;*/
/*  font-size: 21px;*/
/*  font-weight: bold;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.19;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #1261a0;*/
/*}*/

.summary-column {
  border-left: solid 1px rgba(112, 112, 112, 0.12);
}

.columns {
  margin-top: 0;
}
.columns:last-child {
  margin-bottom: 0;
}

/*.Plan {*/
/*  margin-top: 30px;*/
/*  font-family: Montserrat;*/
/*  font-size: 16px;*/
/*  font-weight: bold;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.19;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #58595b;*/
/*}*/

/*.Plan + p {*/
/*  font-family: Open Sans;*/
/*  font-size: 16px;*/
/*  font-weight: normal;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.38;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #58595b;*/
/*}*/

/*.Plan + p + p {*/
/*  margin-top: 5px;*/
/*  font-family: Open Sans;*/
/*  font-size: 14px;*/
/*  font-weight: normal;*/
/*  font-stretch: normal;*/
/*  font-style: normal;*/
/*  line-height: 1.36;*/
/*  letter-spacing: normal;*/
/*  text-align: left;*/
/*  color: #58595b;*/
/*}*/

.agree-label {
  font-family: Open Sans;
  font-size: 16px;
  margin-top: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.agree-label > a, .agree-label > a:visited {
  text-decoration: none;
  color: #58595b;
}

.agree-label > a:hover {
  text-decoration: underline;
  color: #58595b;
}

.agree-label > .checkbox {
  width: 17px;
  height: 17px;
  -webkit-appearance: none;
  border-radius: 0;
  border: solid 1px #ebebeb;
}

input[type=checkbox]:before {
  /* Show some fake element to keep the space for empty "square" */
  content: '\f0c8';
  color: transparent;
}

input[type=checkbox]:checked:before {
  content: '\2713 ';
  /* top: 2px; */
  /* left: 20px; */
  padding-left: 2px;
  font-size: 15px;
  line-height: 0.8;
  color: #58595b;
  font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial;
}

.create-account {
  border: none;
  margin-top: 14px;
  background-color: #1261a0;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

p.ask-sign-in {
  margin-top: 20px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

p.ask-sign-in > a, p.ask-sign-in > a:hover, p.ask-sign-in > a:visited {
  font-weight: normal;
  color: #2fabe1;
  text-decoration: underline;
}

p.want-to-know-more {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

p.want-to-know-more > a, p.want-to-know-more > a:hover, p.want-to-know-more > a:visited {
  color: #30aae1;
  text-decoration: underline;
}

.VuePassword__Toggle {
  color: gray !important;
}

.VuePassword__Input {
  border: none;
  height: 40px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  padding-left:18px;
}

/**
 * TODO: use placeholder solution below if feedback from Alon and Jolandi such that they want a different colour
 */

/*::placeholder { !* Chrome, Firefox, Opera, Safari 10.1+ *!*/
/*  color: red;*/
/*  opacity: 1; !* Firefox *!*/
/*}*/

/*:-ms-input-placeholder { !* Internet Explorer 10-11 *!*/
/*  color: red;*/
/*}*/

/*::-ms-input-placeholder { !* Microsoft Edge *!*/
/*  color: red;*/
/*}*/

/**
 * TODO: END
 */

@media screen and (min-width: 768px) {

  .level {
    height: 40px;
    width: 341px;
    padding-left: 165px;
  }

  .input, .VuePassword {
    width: 341px;
  }

  .radio {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .mar-bot-16 {
    margin-bottom: 12px;
  }

  .column.is-two-thirds {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 73%;
  }

  .column.is-two-thirds + .column {
    padding-left: 50px;
    padding-right: 37px;
  }

  .VuePassword {
    height: 40px;
    /*border: solid 1px #dbdbdb;*/
  }

  .VuePassword > div > input {
    height: 40px!important;
  }

  .create-account {
    width: 355px;
    height: 40px;
  }

  .thank-you-header {
    width: 590px;
    max-width: 610px;
    height: 136px;
    font-family: Montserrat;
    font-size: 56px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #1261a0;
    margin: 20px auto 0 auto;
  }

  .thank-you-msg {
    width: 746px;
    max-width: 755px;
    height: 72px;
    font-family: Open Sans;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    margin: 0 auto;
    color: #58595b;
  }

  .mar-top-10 {
    margin-top: 10px;
  }

  .cc_field {
    width: 103px;
  }

  .cc_info {
    margin-right: 0!important;
  }
}

@media screen and (min-width: 1400px) {
  .container {
    max-width: 1400px;
    width: 1400px;
  }
}

@media screen and (max-width: 767px) {
  .onboard-container > .columns > .column {
    margin-left: 0;
    margin-right: 0;
    padding-left: 30px;
    padding-right: 30px;
  }

  .Create-your-account {
    margin-top: 10px;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #1261a0;
  }

  .router-view {
    margin-top: 50px;
  }

  .Business-details {
    margin-top: 16px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .form-para {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .control {
    width: 100%;
  }

  .field.is-grouped >.control:not(:last-child), .field.is-grouped.is-grouped-multiline>.control:last-child {
    margin-bottom: 10px;
  }

  .input {
    padding-left: 15px;
    height: 35px;
  }

  .VuePassword {
    height: 35px;
    /*border: solid 1px #dbdbdb;*/
  }

  .VuePassword > div > input {
    height: 35px!important;
    padding-left: 15px;
  }

  .User-details {
    margin-top: 20px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .agree-label {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    margin-top: 13px;
    padding-left: 30px;
  }

  .agree-label > .checkbox {
    margin-left: -30px;
  }

  input[type=checkbox]:checked {
    background-color: #ffffff !important;
  }

  .create-account {
    width: 100%;
    height: 40px;
    margin-top: 5px;
  }

  /*.summary {*/
  /*  border-top: solid 1px rgba(112, 112, 112, 0.12);*/
  /*  margin-top: 25px!important;*/
  /*  padding-top: 23px;*/
  /*  font-family: Montserrat;*/
  /*  font-size: 18px;*/
  /*  font-weight: bold;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.22;*/
  /*  letter-spacing: normal;*/
  /*  text-align: center;*/
  /*  color: #1261a0;*/
  /*}*/

  .summary-column {
    margin-top: 0!important;
    padding-top: 0;
  }

  .onboard-container > .columns > .column:first-child {
    padding-bottom: 0;
  }

  /*.Plan {*/
  /*  font-family: Montserrat;*/
  /*  font-size: 14px;*/
  /*  font-weight: bold;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.29;*/
  /*  letter-spacing: normal;*/
  /*  text-align: left;*/
  /*  color: #58595b;*/
  /*  margin-bottom: 8px;*/
  /*}*/

  /*.Plan + p {*/
  /*  font-family: Open Sans;*/
  /*  font-size: 14px;*/
  /*  font-weight: normal;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.36;*/
  /*  letter-spacing: normal;*/
  /*  text-align: left;*/
  /*  color: #58595b;*/
  /*}*/

  /*.want-to-know-more {*/
  /*  font-family: OpenSans;*/
  /*  font-size: 14px!important;*/
  /*  font-weight: normal;*/
  /*  font-stretch: normal;*/
  /*  font-style: normal;*/
  /*  line-height: 1.36!important;*/
  /*  letter-spacing: normal;*/
  /*  text-align: center!important;*/
  /*  color: #58595b;*/
  /*  margin-top: 42px!important;*/
  /*}*/

  .onboard-container > .columns > .column:last-child {
    padding-bottom: 25px;
  }

  .thank-you-hero {
    margin-top: 0!important;
    margin-bottom: 0!important;
  }

  .thank-you-header {
    font-family: Montserrat;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #1261a0;
    margin-top: 23px;
  }

  .thank-you-msg {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: normal;
    text-align: center;
    color: #58595b;
    margin-top: 17px;
  }

  .hero-body {
    padding-bottom: 20px;
  }
}


.rel-pos {
  right: 15px;
  position: absolute;
  top: 11px;
}

.billing-cycle > .control > .button {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  /*text-align: left;*/
  color: rgba(88, 89, 91, 0.6);
  height: 26px;
}

.billing-cycle > .control:first-child > .button {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.billing-cycle > .control:nth-child(even) > .button {
  border-top-right-radius: 5px!important;
  border-bottom-right-radius: 5px!important;
}

.billing-cycle > .control > .button.is-active {
  background-color: #30aae1;
  color: #ffffff;
  border: 0;
}

.discount_copy {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #17bd85;
  padding-left: 11px;
}

.selected_card {
  border: 0.5px solid #17bd85;
  border-radius: 3px;
}

.table {
  margin-top: 35px;
  margin-bottom: 35px;
  padding-bottom: 35px;
  border-bottom: solid 1px rgba(88, 89, 91, 0.32);
}

.table > tr > td:first-child {
  font-weight: bold;
}

.table > tr:last-child > td {
  font-weight: normal;
}

.ok-button {
  width: 355px;
  height: 40px;
  margin: 10px 0 9px 0;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  background-color: #1261a0;
}

.height-100 {
  height: 100px;
}

.flash-msg {
  margin-top:30px!important;
  border: 1px solid #e8573c;
  height: 68px;
}

.flash-msg > .column:first-child {
  background-color: #e8573c;
  color: #ffffff;
  width: 68px;
  line-height: 68px;
}

.flash-msg > .column:nth-child(2) {
  background-color: #fdf5f4;
  color: #e8573c;
}

.flash-msg > .column:nth-child(2) > p {
  color: #e8573c;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 68px;
  letter-spacing: normal;
  text-align: left;
  padding-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/onboarding/Checkout.vue